import React from "react";
import "../../pages/Surveys/style.css";
import cogoToast from "cogo-toast";
 
import { useState, useEffect, useRef, useMemo } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { ListSubmissions } from "../../services/Api";
import { SUCCESS_RESULT } from "../../Constants";
 
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import CardBox from "../../components/CardBox";
 
import { PulseLoader } from "react-spinners";
import { Tabulator } from "survey-analytics/survey.analytics.tabulator";

import { Model } from "survey-core";
import { VisualizationPanel } from "survey-analytics";
import "tabulator-tables/dist/css/tabulator.css";
import "survey-analytics/survey.analytics.tabulator.css";
import jsPDF from 'jspdf';
import { FaMap } from "react-icons/fa";
 
// import { setLicenseKey } from 'survey-core';

// setLicenseKey('NjFmNzY1NDktMjA4OC00ZjZiLTg1YzgtNDYwYTUzZmUzMDk0OzE9MjAyMS0xMS0yNSwyPTIwMjEtMTEtMjUsND0yMDIxLTExLTI1');

 

const Submissions = (props) => {
  const doc = new jsPDF();
  const history = useHistory();
  const [is_processing, setProcessing] = useState(false);
  const [ActiveKey, setActiveKey] = useState("s")
  const { _survey } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState({});
  //visuals
 
 
 let get_unique_collectors = () => {
  let unique_values = responseLocations?.map((item) => item.created_by)
      .filter(
          (value, index, current_value) => current_value.indexOf(value) === index
      );
  return unique_values.length;
};

const [submissions, setsubmissions] = useState([])
 
  const gridRef = useRef();
  const [key, setkey] = useState("");
  const [mode, setmode] = useState(10001);
  const [vizPanel, setVizPanel] = useState(null);
const [responseLocations, setResponseLocations] = useState([])
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);

let timer=null;

  
  useEffect(() => {
    list_submissions(mode);

    // const interval = setInterval(() => {
    //   list_submissions(mode);

    // }, 20000);
    // return () => clearInterval(interval);
   
  }, []);
  const reportTemplateRef = useRef(null);




	const ExportVisuals = () => {
		const doc = new jsPDF({
			format: 'a4',
			unit: 'px',
		});

		// Adding the fonts.
		doc.setFont('Inter-Regular', 'normal');

		doc.html(reportTemplateRef.current, {
			async callback(doc) {
				await doc.save('document');
			},
		});
	};
  const _ExportVisuals = (id) => {
    alert("Visuals Exported : "+id);
    var source = window.document.getElementById(id)[0];

    doc.html("<h1>HERE WE GO NOW</h1>", {
      async callback(doc) {
        await doc.save('SurveyVisuals.pdf');
      },
    });
// 
  }
  const list_submissions = (_mode) => {
    window.GenerateSubmissionsTable(JSON.parse(_survey?.questionnaire), []);
    // window.GenerateVisuals(JSON.parse(_survey?.questionnaire), [], 0);

    setProcessing(true);

    ListSubmissions({
      survey_id: _survey?.survey_id,
      mode: _mode,
    })
      .then((res) => {
        setProcessing(false);
        //gridRef.current.api.showLoadingOverlay();
        if (res.status == 200) {
          var response = res.data;
          console.clear();

          if (response.status == SUCCESS_RESULT) {
            let subs = [];
             let locations=[];

            response.data.forEach((s) => {
              let _id=Math.random().toString(16).slice(2);
              locations.push({location:JSON.parse(s.location),endedOn:s.endedOn,id:_id,name:s.created_by})
             

let _submission=JSON.parse(s.submissions);
 
_submission.location=JSON.parse(s.location);
               
                
              
              subs.push(_submission);
           
           
           
           
            });
            setResponseLocations(locations)


            // set submisions
            setsubmissions(subs)
            setRowData(subs);
          setTimeout(() => {
            setActiveKey('s');

            getTabulation();
          
          }, 500);
          
            // window.GenerateSubmissionsTable(
            //   JSON.parse(_survey?.questionnaire),
            //   subs
            // );
 
            
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        } else {
          {
            cogoToast.error(res.message, {
              hideAfter: 5,
            });
          }
          cogoToast.error(res.message, {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.log(err);
        cogoToast.error(err, {
          hideAfter: 5,
        });

        cogoToast.error("Something went wrong, please Try again.", {
          hideAfter: 5,
        });
      });
  };

function generateVisuals() {
  

  const vizPanelOptions = {
    allowHideQuestions: false,
    haveCommercialLicense: true,
  };

  const surveyX = new Model(_survey?.questionnaire);

   
  
   
    const vizPanel = new VisualizationPanel(
      surveyX.getAllQuestions(),
      submissions,
      vizPanelOptions
    );


    
    var vizPanelx = new  Tabulator(
      surveyX,

      submissions
  );
      
      vizPanelx.render("surveyDashboardContainer");
  //   try{

   

  //   surveyX.getAllQuestions().forEach(function(question) {
  //     var visualizer = vizPanel.getVisualizer(question.name);
  //    // visualizer.showHeader = false;
  //     // "pie" for "checkbox" and "bar" for "radiogroup"
  //     if(question.getType() === "checkbox" || question.getType() === "dropdown") {
  //         visualizer.setChartType("pie");
  //     }
  //     if(question.getType() === "radiogroup") {
  //         visualizer.setChartType("doughnut");
  //     }
  //   })
  // }catch(e){
  //   alert(e);
  // }
   
  try{

  
    setVizPanel(vizPanel);
    setTimeout(() => {
      vizPanel?.render("surveyVizPanel");
    }, 500);
  }catch(e){alert(e)}





 
}
function getTabulation() {
   
  if(submissions.length==0){
    return;
  }

  let questionnaire=JSON.parse(_survey?.questionnaire);
 
questionnaire.pages[0].elements.push(  {
  "type": "multipletext",
  "name": "location",
  "title": "location",
  "items": [
   {
    "name": "latitude",
    "inputType": "number"
   },
   {
    "name": "longitude",
    "inputType": "number"
   }
  ]
 }
)
 
console.clear();
console.log(submissions)
 

  const surveyX = new Model(JSON.stringify(questionnaire));

    var vizPanel = new  Tabulator(
      surveyX,

      submissions
  );
      
  vizPanel.render("surveyDashboardContainer");
 
}


const goToSubmissions = () => {
  setActiveKey("s");
};










  return (
    <div>
      <h2>Surveys → {_survey?.name} → Result</h2>
      <br/>
      <h4>{_survey?.description}</h4>
      <br/>

<div className="row">
  <div className="col-md-4">
<h3>     <div className="input-group">
          <h1 className="text-center justify-content-center align-self-center">
            Survey Mode : 
          </h1>
          <br/>
<select className="form-control" onChange={(e)=>{
  setmode(e.target.value);
 list_submissions(e.target.value);

}}>
  <option value={10001}>LIVE</option>
  <option value={10002}>TRAINING</option>

</select>
<br/>


          {/* <button
            onClick={() => {
              setRowData([])
              setmode(10001);
              list_submissions(10001);
             
            }}
            type="button"
            className={
              mode == 10001 ? "btn btn-success btn-pill" : "btn btn-pill"
            }
          >
            Live
          </button>
          <button
            className="text-center btn"
            onClick={() => {
            
           
                
            }}
          >
            <b>⇄</b>
          </button>

          <button
            type="button"
            onClick={() => {
              setRowData([])
                setmode(10002);
                list_submissions(10002);
              
                

            }}
            className={
              mode == 10002 ? "btn btn-primary btn-pill" : "btn btn-pill  "
            }
          >
            Training
          </button>
           */}

       
        </div>
      </h3>
      <br/>

      <button 
  className="btn btn-primary"
  disabled={responseLocations.length==0}
 onClick={()=>{

 

  history.push({
    pathname: "/ebms/surveys/submissions-map",
    state: { responseLocations:responseLocations,surveyName:_survey?.name  }
});
 }}>
  <FaMap> </FaMap> &nbsp;
  View Geolocation Map
  </button>
      {/* <button onClick={()=>list_submissions(mode)}>Refresh</button> */}

  </div>
  <div className="col-md-8">
<div className="row">
    
  <CardBox title={"RESPONSES"} value={ rowData.length} icon={"fas fa-poll"}  ></CardBox>
<CardBox title={"DATA COLLECTORS"} value={get_unique_collectors()} icon={"fa fa-users"}  ></CardBox>
<CardBox title={"OUTLIERS RESPONSES "} value={0} icon={"fa fa-group"}  ></CardBox>


</div>
 
  
  </div>
</div>

      
    
  {/* {JSON.stringify(responseLocations)} */}
 


      
      {is_processing && (
        <center>
          <PulseLoader loading={true} color="blue"></PulseLoader>
        </center>
      )}
<br/>
      <Tabs
        activeKey={key}
        onSelect={(k) => setkey(k)}
        className="nav-tabs"
        defaultActiveKey={"s"}
        onEnter={()=>{
        
          
        }}
    
      >
        <Tab eventKey="s" title="Submissions"
     
        onEnter={()=> getTabulation()}
   
        >
          <button
            className="btn btn-primary"
            onClick={() => {
              window.ExportToExcel();
            }}
          >
            <span>
              <i className="fa fa-download bigger-110 blue"></i>&nbsp;Export
              Submissions.
            </span>
          </button>
          {/* <div id="displayTable"></div> */}
          <div id="surveyDashboardContainer"></div>

          
        </Tab>
        <Tab
          eventKey="v"
          title="Survey Visuals"
          onEnter={()=>generateVisuals()}
          // onEnter={handleClick}
          // onEnter={(e) =>
          //   window.GenerateVisuals(
          //     JSON.parse(_survey?.questionnaire),
          //     rowData,
          //     0
          //   )
          // }
        >
           <button
            className="btn btn-primary"
            onClick={() => {
              ExportVisuals("surveyVizPanel");
            }}
          >
            <span>
              <i className="fa fa-download bigger-110 blue"></i>&nbsp;Export
              Visuals.
            </span>
          </button>
          {/* <select
            className="form-control"
            // onChange={(e) =>
            //   window.GenerateVisuals(
            //     JSON.parse(_survey?.questionnaire),
            //     rowData,
            //     e.target.value
            //   )
            // }
          >
            <option>Select Page</option>
            {JSON.parse(_survey?.questionnaire).pages.map((p, i) => {
              return <option value={i}>{p.name}</option>;
            })}
          </select> */}
          		<div ref={reportTemplateRef}>
              <div id="surveyVizPanel" /> 
			</div>
          

          <div id="error"></div>
          <div id="surveyResult"></div>
        </Tab>
       
      </Tabs>

        
    </div>
  );
};

export default Submissions;
